
  function initChat(envName) {
    if (window.liveagent) {
        delete liveagent;
        console.log('inside liveagent delete');
    }
    if (window.liveAgentDeployment) {
        delete liveAgentDeployment;
        console.log('inside liveagentDeployment delete');
    }
    if (envName == 'Prod') {
        $.loadScript('https://c.la2w1.salesforceliveagent.com/content/g/js/40.0/deployment.js', function () { reInitChat(envName); });
    }
    else {
        $.loadScript('https://c.la3-c1cs-ia4.salesforceliveagent.com/content/g/js/57.0/deployment.js', function () { reInitChat(envName); });
    }
}
var reInitChat = function (envName) {
    var lsOrgID = '';
    var lsURL = '';
    if (envName == 'Test') {
        lsOrgID = '00D7d0000077nEF';
        lsURL = 'https://d.la3-c1cs-ia4.salesforceliveagent.com/chat';
    }
    else {
        lsOrgID = '00D60000000JGEk';
        lsURL = 'https://d.la2w1.salesforceliveagent.com/chat';
    }
    console.log(lsOrgID);
    console.log(lsURL);
    window._laq = [];
    window._laq.push(function () {
        liveagent.showWhenOnline('57360000000Kyxu', document.getElementById('liveagent_button_online_57360000000Kyxu'));
        liveagent.showWhenOffline('57360000000Kyxu', document.getElementById('liveagent_button_offline_57360000000Kyxu'));
    });
    liveagent.setChatWindowWidth(550);
    // Sets the height of the chat window to 500px
    liveagent.setChatWindowHeight(600);
    liveagent.init(lsURL, '57260000000Kywc', lsOrgID);
};

   function initJSSIChat(envName) {
    if (window.liveagent) {
      delete liveagent;
    }

    if (window.liveAgentDeployment) {
      delete liveAgentDeployment;
    }

    if (envName == 'Prod') {
      $.loadScript('https://c.la2w1.salesforceliveagent.com/content/g/js/40.0/deployment.js', function() {reInitJSSIChat(envName);});
    } else {
      $.loadScript('https://c.la3-c1cs-ia4.salesforceliveagent.com/content/g/js/57.0/deployment.js', function () { reInitJSSIChat(envName); });
    }
  }

  var reInitJSSIChat =   function(envName) {
   // https://d.la3-c1cs-ia5.salesforceliveagent.com/chat
      var lsOrgID = ''
      var lsURL = '';
      if (envName=='Test') {
        lsOrgID = '00D7d0000077nEF';
        lsURL = 'https://d.la3-c1cs-ia4.salesforceliveagent.com/chat';
      } else {
        lsOrgID = '00D60000000JGEk';
        lsURL = 'https://d.la2w1.salesforceliveagent.com/chat';
      }
      console.log(lsOrgID);
      console.log(lsURL);
      console.log(envName);

      window._laq = [];
      window._laq.push(function () {
          liveagent.showWhenOnline('57360000000KyyO', document.getElementById('liveagent_button_online_57360000000KyyO'));
          liveagent.showWhenOffline('57360000000KyyO', document.getElementById('liveagent_button_offline_57360000000KyyO'));
      });


      liveagent.setChatWindowWidth(450);
      // Sets the height of the chat window to 750px
      liveagent.setChatWindowHeight(850 + ",resizable\x3d1,scrollbars\x3d1");

      liveagent.init(lsURL, '57260000000Kywc', lsOrgID);
   }

  $.loadScript = function (url, callback) {
      $.ajax({
       url: url,
      dataType: 'script',
      success: callback,
      async: true
      });
  };





// WEBPACK FOOTER //
// src/assets/js/livechat.js